export const getIconColor = (isPassed) => (isPassed ? 'green' : 'grey')
